import { z } from 'zod';
import { emailValidator } from '../../utils/common';
export const RegisterSocialSchema = z
    .object({
    email: emailValidator,
    provider: z
        .enum(['facebook', 'google', 'apple'])
        .describe('Social auth provider (facebook/google/apple)')
})
    .describe('Register Social object with email and provider');
//# sourceMappingURL=registerSocialSchema.js.map